import { render, staticRenderFns } from "./Sidentify.vue?vue&type=template&id=e5f3077c&scoped=true&"
import script from "./Sidentify.vue?vue&type=script&lang=js&"
export * from "./Sidentify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f3077c",
  null
  
)

export default component.exports